import { render } from "./PromReportEditView.vue?vue&type=template&id=4010399c"
import script from "./PromReportEditView.vue?vue&type=script&lang=js"
export * from "./PromReportEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__